define([
	"dojo/_base/declare",
	"ProductSpec/SizeChart/RevisedPattern"
], function(declare,RevisedPattern) {

	return declare(RevisedPattern, {
		cssBaseSize: " tableSizeChartPatternWithShrinkageRevisedBase",
		cssOffBaseSize: " tableSizeChartPatternWithShrinkageRevised",
		idOriginal: "PatternWithShrinkage",
		idRevised: "RevisedPatternWithShrinkage"
	});
});